const routes = [
  {
    path: "/payments",
    component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/autoBillingPage/AutobillingPage"),
    children: [
      {
        path: "auto-billing",
        name: "autoBillingPage",
        component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/autoBillingPage/AutobillingPage")
      },
      {
        path: "*",
        redirect: { name: "autoBillingPage" }
      }
    ]
  },
  {
    path: "/payment_matcher",
    component: () => import(/* webpackChunkName: "PaymentMatcher" */ "./components/PaymentMatcher/PaymentMatcher"),
  },
  {
    path: "/payments-upgrade",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/Upgrade")
  },
  {
    path: "/payments-upgrade-page",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/UpgradePage")
  },
  {
    path: "/payments-trial-upsell",
    component: () => import(/* webpackChunkName: "upgrade" */ "./views/trialUpsell/PaymentsTrialUpsellDialog")
  },
  {
    path: "/payments-transaction-reports-empty",
    component: () => import(/* webpackChunkName: "transactionReports" */ "./views/transactionsReport/EmptyState")
  },
  {
    path: "/deposit-without-pg-dialog",
    name: "depositWithoutPgDialog",
    component: () => import(/* webpackChunkName: "depositWithoutPgDialog" */ "./components/depositWithoutPgDialog/depositWithoutPgDialog")
  },
];
export default routes;
